<div class="page">
  <div class="header" id="top">
    <app-header></app-header>
  </div>
  <div #container class="content" scroll-directive (scrollPosition)="scrollChanged($event)">
    <div class="content_scrollbar">
      <app-content></app-content>
    </div>
    <div [ngClass]="navIsFixed? 'show-scroll' : ''" (click)="scrollToTop($event)" class="scroll-to-top">
      <div class="triangle"></div>
    </div>
  </div>
</div>
